// extracted by mini-css-extract-plugin
export default {"fullVideo":"BgVideos_fullVideo__0IQqa","unVisible":"BgVideos_unVisible__hClkh","leftVideo":"BgVideos_leftVideo__jF5LG"};